<div class="cookie-consent" *ngIf="showConsent" [@inOutAnimation]>
  <h3 *ngIf="(isCustomTranslationsEnabled$ | async) !== null" [ngClass]="activeCountry$ | async">
    {{
      'cookieConsent.title'
        | cxTranslate
          : {
              context: setCustomContext(
                isCustomTranslationsEnabled$ | async,
                activeCountry$ | async,
                activeLanguage$ | async
              )
            }
    }}
  </h3>
  <p [innerHTML]="content$ | async"></p>
  <button
    class="primary-btn"
    (click)="onCookieAccepted()"
    *ngIf="(isCustomTranslationsEnabled$ | async) !== null"
    [ngClass]="activeCountry$ | async"
  >
    {{
      'cookieConsent.continue'
        | cxTranslate
          : {
              context: setCustomContext(
                isCustomTranslationsEnabled$ | async,
                activeCountry$ | async,
                activeLanguage$ | async
              )
            }
    }}
  </button>
</div>
